export default function HiveFlowLogo({ className = "h-10 w-10" }) {
  const logoSource = window.location.protocol === "file:" ? "./HF_NoBackground.svg" : "/HF_NoBackground.svg";
  return (
    <img
      src={logoSource}
      alt=""
      aria-hidden="true"
      className={`${className} object-contain`}
      draggable="false"
    />
  );
}
